module.exports = __webpack_public_path__ + "assets/img/ICI-UK-Content-Marketing-w540.faf46515.webp";